import { FC } from 'react';

interface CancelConfirmDialogProps {
  isFullCancel: boolean;
  hasDeliveryItems: boolean;
  selectedIds: Set<string>;
  cancelReason: string;
  setCancelReason: (v: string) => void;
  isCancelling: boolean;
  setShowCancelConfirm: (v: boolean) => void;
  handleCancelRequest: () => Promise<void>;
}

export const CancelConfirmDialog: FC<CancelConfirmDialogProps> = ({
  isFullCancel,
  hasDeliveryItems,
  selectedIds,
  cancelReason,
  setCancelReason,
  isCancelling,
  setShowCancelConfirm,
  handleCancelRequest,
}) => {
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
      <div
        className="fixed inset-0 bg-black/40"
        onClick={() => !isCancelling && setShowCancelConfirm(false)}
      />
      <div className="relative w-full max-w-md rounded-xl bg-white p-6 shadow-2xl">
        <h3 className="text-lg font-bold text-gray-900">
          {isFullCancel ? '전체취소 확인' : '부분취소 확인'}
        </h3>
        <p className="mt-2 text-sm text-gray-600">
          {isFullCancel
            ? `주문 전체를 취소합니다. 전액 환불됩니다.`
            : `선택한 쿠폰 ${selectedIds.size}건을 취소합니다. 해당 금액만 환불됩니다.`}
        </p>

        {isFullCancel && hasDeliveryItems && (
          <div className="mt-2 rounded-lg bg-amber-50 px-3 py-2 text-xs text-amber-700">
            배송 상품도 함께 전체취소됩니다.
          </div>
        )}

        <div className="mt-4">
          <label className="block text-sm font-medium text-gray-700">
            취소 사유 <span className="text-red-500">*</span>
          </label>
          <textarea
            value={cancelReason}
            onChange={(e) => setCancelReason(e.target.value)}
            placeholder="취소 사유를 입력하세요"
            className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-red-400 focus:outline-none focus:ring-1 focus:ring-red-400"
            rows={3}
          />
        </div>

        <div className="mt-5 flex gap-3">
          <button
            onClick={() => setShowCancelConfirm(false)}
            disabled={isCancelling}
            className="flex-1 rounded-lg border border-gray-300 py-2.5 text-sm font-medium text-gray-600 hover:bg-gray-50 disabled:opacity-50"
          >
            닫기
          </button>
          <button
            onClick={handleCancelRequest}
            disabled={isCancelling || !cancelReason.trim()}
            className="flex-1 rounded-lg bg-red-600 py-2.5 text-sm font-bold text-white hover:bg-red-700 disabled:opacity-50"
          >
            {isCancelling
              ? '처리중...'
              : isFullCancel
              ? '전체취소 실행'
              : '부분취소 실행'}
          </button>
        </div>
      </div>
    </div>
  );
};
